import { apiClient } from '@/lib/apiClient';

import type { EnvioInforme, EnvioInformeRequest, EnvioInformeWhatsAppRequest } from './types';

export const enviosApi = {
  /** POST /protocolos/{uid}/informe-parcial/enviar — Status 202. */
  async enviarParcial(
    uidProtocolo: string,
    body: EnvioInformeRequest = {},
    signal?: AbortSignal
  ): Promise<EnvioInforme> {
    const response = await apiClient.post<EnvioInforme>(
      `/protocolos/${uidProtocolo}/informe-parcial/enviar`,
      body,
      { signal }
    );
    return response.data;
  },

  /** POST /protocolos/{uid}/informe-final/enviar — Status 202. */
  async enviarFinal(
    uidProtocolo: string,
    body: EnvioInformeRequest = {},
    signal?: AbortSignal
  ): Promise<EnvioInforme> {
    const response = await apiClient.post<EnvioInforme>(
      `/protocolos/${uidProtocolo}/informe-final/enviar`,
      body,
      { signal }
    );
    return response.data;
  },

  /**
   * GET /protocolos/{uid}/envios
   * Devuelve array directo (no paginado).
   */
  async listByProtocolo(uidProtocolo: string, signal?: AbortSignal): Promise<EnvioInforme[]> {
    const response = await apiClient.get<EnvioInforme[]>(
      `/protocolos/${uidProtocolo}/envios`,
      { signal }
    );
    return response.data;
  },

  /** POST /protocolos/{uid}/informe-parcial/enviar-whatsapp — Status 202. */
  async enviarParcialWhatsApp(
    uidProtocolo: string,
    body?: EnvioInformeWhatsAppRequest | null,
    signal?: AbortSignal
  ): Promise<EnvioInforme> {
    const response = await apiClient.post<EnvioInforme>(
      `/protocolos/${uidProtocolo}/informe-parcial/enviar-whatsapp`,
      body ?? null,
      { signal }
    );
    return response.data;
  },

  /** POST /protocolos/{uid}/informe-final/enviar-whatsapp — Status 202. */
  async enviarFinalWhatsApp(
    uidProtocolo: string,
    body?: EnvioInformeWhatsAppRequest | null,
    signal?: AbortSignal
  ): Promise<EnvioInforme> {
    const response = await apiClient.post<EnvioInforme>(
      `/protocolos/${uidProtocolo}/informe-final/enviar-whatsapp`,
      body ?? null,
      { signal }
    );
    return response.data;
  },

  /**
   * POST /envios/{uid}/reintentar — Status 202.
   * Solo permitido si status_global es "todos_fallidos" o "parcial".
   */
  async reintentar(uidEnvio: string, signal?: AbortSignal): Promise<EnvioInforme> {
    const response = await apiClient.post<EnvioInforme>(
      `/envios/${uidEnvio}/reintentar`,
      {},
      { signal }
    );
    return response.data;
  },
};
